

export enum ConversationScoreMethod {
    Percentage = 1,
    PercentageWithCustomCap = 2,
    RatingScale = 4
}
